import { Lien } from "../lib/router.tsx";
import { useApp } from "../app/state.tsx";

/** Tableau de bord exposant (B1) — vue de synthèse. Données de démonstration hors réservation. */
export function ExposantDashboard(): React.ReactElement {
  const app = useApp();
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, maxWidth: 940 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(210px,1fr))", gap: 14 }}>
        <Stat titre="Ma réservation" valeur="Brouillon" pilule={<span className="pill pill-warn">à valider</span>} />
        <Stat titre="Emplacement" valeur="En attente" pilule={<span className="pill pill-muted">bureau</span>} />
        <Stat titre="Collaborateurs" valeur="3" />
        <Stat titre="Prospects scannés" valeur="0" />
      </div>

      <div className="card" style={{ padding: 22, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
        <div>
          <h2 className="display" style={{ fontSize: 18, margin: "0 0 4px" }}>Réservez votre stand {app.edition.optionLabel}</h2>
          <p style={{ margin: 0, color: "var(--muted)", fontSize: 13.5 }}>Choisissez votre stand et vos options, puis validez pour lancer la facturation.</p>
        </div>
        <Lien vers="/exposant/reservation" className="btn btn-primary" style={{ textDecoration: "none" }}>Composer ma réservation →</Lien>
      </div>

      <div className="card" style={{ padding: 22 }}>
        <span className="eyebrow">Prochaines échéances</span>
        <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 10 }}>
          {[
            { t: "Clôture des réservations de stands", d: "à définir", s: "warn" as const },
            { t: "Ouverture du plan des emplacements", d: "après attribution", s: "muted" as const },
            { t: "Téléchargement des badges équipe", d: "après validation", s: "muted" as const },
          ].map((e) => (
            <div key={e.t} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, paddingBottom: 10, borderBottom: "1px solid var(--line)" }}>
              <span style={{ fontSize: 13.5 }}>{e.t}</span>
              <span className={`pill pill-${e.s}`} style={{ textTransform: "none", fontFamily: "var(--sans)", fontSize: 12 }}>{e.d}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Stat({ titre, valeur, pilule }: { titre: string; valeur: string; pilule?: React.ReactNode }): React.ReactElement {
  return (
    <div className="card" style={{ padding: 16, display: "flex", flexDirection: "column", gap: 6 }}>
      <span className="eyebrow">{titre}</span>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8 }}>
        <span className="display" style={{ fontSize: 22 }}>{valeur}</span>
        {pilule}
      </div>
    </div>
  );
}
